import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable, of, Subject, takeUntil } from 'rxjs';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { HttpService } from '../http/http.service';
import { ApiMethod, Endpoints, FORMAT } from '../utils/constants';

@Injectable({
  providedIn: 'root',
})
export class SiteInspectionService {
  staticText: any = TranslationService.staticTextData;
  grievanceConfig: any = {
    title: this.staticText?.common?.inspection_info,
    key: 'inspection_details',
    columns: 3,
    sectionType: 'multiple', // This section allows multiple entries
    meta: {
      inlineEdit: false,
      showCustomAction: true,
      customActions: [
        {
          title: this.staticText?.common?.proceed_inspection,
          icon: 'fa fa-person-walking-arrow-right',
          action: this.followupInspection.bind(this),
        },
      ],
      viewActionBtn: {
        enable: true,
        btnLabel: `Create Inspection`,
        action: () => {},
      },
      modalConfig: { width: '1200px' },
      btnText: this.staticText?.common?.add_product_info,
      btnActionText: ' Inspection',
      uniqueFields: [],
      bulkUpload: {
        enable: false,
      },
      viewConfig: {
        action: true,
        showImgPreview: false,
        previewRefField: 'attachments',
      },
      noRecTemplate: `<div class="no_records_data">
        <img src="../../../../../assets/images/common/icons_usp/No records created.svg" alt="records_img"/>
        <div class="no_forcast_data">${this.staticText?.common?.no_entries_added_yet}</div>
        <div>`,
    },
    layout: 'table',
    fields: [
      {
        type: 'hidden',
        label: this.staticText?.common?.inspection_id,
        name: 'id',
        required: false,
        validators: [],
        meta: {
          table_display:false
        },
      },
      {
        type: 'text',
        label: this.staticText?.common?.inspection_id,
        name: 'inspection_id',
        required: false,
        validators: [],
        meta: {},
      },
      {
        type: 'hidden',
        label: this.staticText?.common?.inspection_title,
        name: 'inspection_title',
        required: false,
        validators: [],
        meta: {},
      },
      {
        type: 'select',
        label: this.staticText?.common?.inspection_type,
        name: 'inspection_type',
        required: false,
        validators: [],
        meta: {},
      },
      {
        type: 'select',
        label: this.staticText?.common?.scp_name,
        name: 'scp_name',
        required: false,
        validators: [],
        meta: {},
      },
      {
        type: 'select',
        label: this.staticText?.common?.business_sites,
        name: 'business_site',
        required: false,
        validators: [],
        meta: {},
      },
      {
        type: 'select',
        label: this.staticText?.common?.district,
        name: 'district',
        required: false,
        validators: [],
        meta: {},
      },
      {
        type: 'text',
        label: this.staticText?.common?.inspector_name,
        name: 'inspector_name',
        required: false,
        validators: [],
        meta: {},
      },
      {
        type: 'date',
        label: this.staticText?.common?.inspection_start_date,
        name: 'inspection_start_date',
        required: false,
        validators: [],
        meta: {},
      },
      {
        type: 'date',
        label: this.staticText?.common?.inspection_end_date,
        name: 'inspection_end_date',
        required: false,
        validators: [],
        meta: {},
      },
    ],
  };
  listConfig: any = {
    title: this.staticText?.common?.inspection_info,
    key: 'inspection_details',
    columns: 3,
    sectionType: 'multiple', // This section allows multiple entries
    meta: {
      inlineEdit: false,
      showCustomAction: true,
      customActions: [
        {
          title: this.staticText?.common?.proceed_inspection,
          icon: 'fa fa-person-walking-arrow-right',
          action: this.followupInspection.bind(this),
        },
      ],
      viewActionBtn: {
        enable: true,
        btnLabel: `Create Inspection`,
        action: () => { },
      },
      modalConfig: { width: '1200px' },
      btnText: this.staticText?.common?.add_product_info,
      btnActionText: ' Inspection',
      uniqueFields: [],
      bulkUpload: {
        enable: false,
      },
      viewConfig: {
        action: true,
        showImgPreview: false,
        previewRefField: 'attachments',
      },
      noRecTemplate: `<div class="no_records_data">
        <img src="../../../../../assets/images/common/icons_usp/No records created.svg" alt="records_img"/>
        <div class="no_forcast_data">${this.staticText?.common?.no_entries_added_yet}</div>
        <div>`,
    },
    layout: 'table',
    fields: [
      {
        type: 'hidden',
        label: this.staticText?.common?.inspection_id,
        name: 'id',
        required: false,
        validators: [],
        meta: {
          table_display: false
        },
      },
      {
        type: 'text',
        label: this.staticText?.common?.inspection_id,
        name: 'inspection_id',
        required: false,
        validators: [],
        meta: {},
      },
      {
        type: 'hidden',
        label: this.staticText?.common?.inspection_title,
        name: 'inspection_title',
        required: false,
        validators: [],
        meta: {},
      },
      {
        type: 'select',
        label: this.staticText?.common?.inspection_type,
        name: 'inspection_type',
        required: false,
        validators: [],
        meta: {
          table_display: false
        },
      },
      {
        type: 'select',
        label: this.staticText?.common?.scp_name,
        name: 'scp_name',
        required: false,
        validators: [],
        meta: {
          table_display: false
        },
      },
      {
        type: 'select',
        label: this.staticText?.common?.business_sites,
        name: 'business_site',
        required: false,
        validators: [],
        meta: {
          table_display: false
        },
      },
      {
        type: 'select',
        label: this.staticText?.common?.district,
        name: 'district',
        required: false,
        validators: [],
        meta: {},
      },
      {
        type: 'select',
        label: this.staticText?.common?.inspection_coverage,
        name: 'inspection_coverage',
        required: false,
        validators: [],
        meta: {},
      },
      {
        type: 'text',
        label: this.staticText?.common?.inspector_name,
        name: 'inspector_name',
        required: false,
        validators: [],
        meta: {},
      },
      {
        type: 'date',
        label: this.staticText?.common?.inspection_start_date,
        name: 'inspection_start_date',
        required: false,
        validators: [],
        meta: {
          date_format: FORMAT.DATE_FORMAT
        },
      },
      {
        type: 'date',
        label: this.staticText?.common?.inspection_end_date,
        name: 'inspection_end_date',
        required: false,
        validators: [],
        meta: {
          date_format: FORMAT.DATE_FORMAT
        },
      },
    ],
  };

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly _http: HttpService,
    private readonly _router: Router
  ) {}

  private buildEndpoint(base: string, param?: any): string {
    return param ? `${base}${param}` : base;
  }

  private makeRequest(endpoint: any, method: ApiMethod): Observable<any> {
    return this._http.requestCall(endpoint, method).pipe(
      map((e: any) => e),
      takeUntil(this.destroy$)
    );
  }

  followupInspection(data: any, site: any, inspection: any): void {
    this._router.navigate([`law-enforcement/inspection/onboard-inspection`], {
      queryParams: { reference_type: 'onboard', reference_id: 2, scp_type: 2 },
    });
  }

  getInspectionDetails(param: any): Observable<any> {
    let endpoint: any = `${Endpoints.PREPOPULATE_INSPECTION}?reference_type=${param?.reference_type}&reference_id=${param?.reference_id}&scp_type=${param?.scp_type}`;
    return this.makeRequest(endpoint, ApiMethod.GET);
  }

  getInspectionList(param: any, isMandatoryAPI: boolean): Observable<any> {
    if (isMandatoryAPI) return this.getMandatoryData(param);
    else return this.getOptionalData();
  }

  private getMandatoryData(param: any): Observable<any> {
    let endpoint: any = `${Endpoints.GET_INSPECTION}?${param}`;
    return this.makeRequest(endpoint, ApiMethod.GET);
  }
  private getOptionalData(): Observable<any> {
    return of([]).pipe(takeUntil(this.destroy$));
  }
}
